<template>
  <div>
    <v-container id="partnerInfoHeader" fluid>
      <v-row justify="center" align="center" style="height: 160px">
        <v-col xl="6">
          <v-row justify="center">
            <v-col xl="2" lg="1" md="1">
              <simple-image class="partner-image" :id="this.partner.imageId" />
            </v-col>
            <v-col
              xl="9"
              lg="5"
              md="5"
              offset-xl="0"
              offset-lg="1"
              offset-md="1"
            >
              <a
                class="linkPartner"
                :href="this.partner.partnerUrl"
                target="_blank"
              >
                <p class="namePartner">{{ this.partner.title }}</p>
              </a>
              <p class="datePartner" v-if="isShowPartnerDate">
                <span>{{ $t("partners.Client") }} {{ this.partner.date }}</span>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-spacer></v-spacer>
    <v-container id="partnerInfoDescription">
      <h1 class="decriptionHeader">{{ $t("partners.UsedModules") }}</h1>
      <div
        v-for="(description, index) in this.partner.products"
        :key="index"
        class="partnerDesxription"
      >
        <h1 class="descriptionName">{{ description.name }}</h1>
        <p style="font-size: 14px" v-html="description.content" />
      </div>
    </v-container>
  </div>
</template>

<script>
import serviceDataAccess from "../../services/service.data-access";
import SimpleImage from "../_shared/SimpleImageDisplay.vue";
import Cookie from "vue-cookie";
import store from "../../store/store._index";

export default {
  name: "partnerInfo",
  components: { SimpleImage },
  props: {
    id: String
  },
  data: () => ({
    partner: {}
  }),
  async created() {
    // var id = document.URL.split('/').pop()
    var loc = Cookie.get("locale");
    const language = !loc ? "uk" : loc;
    const result = await serviceDataAccess.getPartner(this.id);
    store.dispatch("setPartnerLocalizationData", result);
    this.partner = store.getters[`partner${language}`];
    console.log(this.partner);
  },
  computed: {
    isShowPartnerDate() {
      return this.partner.date && this.partner.date !== 1970 ? true : false;
    }
  }
};
</script>

<style lang="scss">
#partnerInfoHeader {
  background-color: #ffffff;
  .namePartner {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 12px;
  }
  .linkPartner {
    font-weight: 400;
    font-size: 18px;
    text-decoration: none;
    color: #3a3a3a;
    &:hover {
      color: #3883ad;
    }
  }
  .datePartner {
    background-color: #eff0f3;
    margin-top: 12px;
    width: 133px;
    span {
      padding: 4px;
      font-weight: 400;
      font-size: 18px;
      color: #3a3a3a;
      text-transform: uppercase;
    }
  }
  .partner-image {
    max-width: 155px;
    max-height: 155px;
    padding: 15px;
  }
}
#partnerInfoDescription {
  width: 56%;
  background-color: #ffffff;
  margin-top: 32px;
  margin-bottom: 32px;

  .partnerDesxription {
    p {
      padding-right: 24px;
      padding-left: 24px;
      padding-bottom: 32px;
      font-size: 20px;
    }
  }
  .decriptionHeader {
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 24px;
    font-weight: 600;
    color: #3a3a3a;
    font-size: 30px;
  }
}
</style>
